import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-710d04b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "spin"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "ion-padding-vertical" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "ion-padding-vertical" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 3 }
const _hoisted_9 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_payment_info = _resolveComponent("payment-info")!
  const _component_order_info = _resolveComponent("order-info")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createBlock(_component_ion_content, { class: "ion-padding ion-text-center" }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true),
      ($setup.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_ion_spinner)
          ]))
        : (_openBlock(), _createBlock(_component_ion_grid, { key: 1 }, {
            default: _withCtx(() => [
              ($setup.order.status == $setup.ORDER_STATUSES.pendingPayment)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createElementVNode("h4", _hoisted_3, _toDisplayString($setup.t('orderPendingPayment' )), 1),
                    _createVNode(_component_ion_icon, {
                      class: "large-icon",
                      color: "warning",
                      icon: $setup.alertCircle
                    }, null, 8, ["icon"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("h4", _hoisted_5, _toDisplayString($setup.t('orderPlaced' )), 1),
                    _createVNode(_component_ion_icon, {
                      class: "done-icon",
                      icon: $setup.checkmarkCircle
                    }, null, 8, ["icon"])
                  ])),
              _withDirectives(_createElementVNode("div", null, [
                _createElementVNode("h6", null, _toDisplayString($setup.t('yourOrderCodeIs' )), 1),
                _createVNode(_component_ion_text, { color: "primary" }, {
                  default: _withCtx(() => [
                    _createElementVNode("h2", null, _toDisplayString($setup.order.code), 1)
                  ]),
                  _: 1
                })
              ], 512), [
                [_vShow, $setup.order.code]
              ]),
              _hoisted_6,
              ($setup.order.status == $setup.ORDER_STATUSES.pendingPayment)
                ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
                    ($setup.order.paymentMethod == 'card')
                      ? (_openBlock(), _createBlock(_component_ion_text, {
                          key: 0,
                          color: "danger"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("p", null, _toDisplayString($setup.t('failedCreditCardPayment')), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString($setup.t('msgOrderPendingPayment')), 1)
                  ]))
                : (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString($setup.t('msgOrderConfirmed')), 1)),
              _createElementVNode("p", {
                innerHTML: $setup.getLocalizedStr($setup.settings, 'extraThankYouOrderMsg', 'extraThankYouOrderMsgEn')
              }, null, 8, _hoisted_9),
              _withDirectives(_createVNode(_component_payment_info, {
                orderCode: $setup.order.code
              }, null, 8, ["orderCode"]), [
                [_vShow, $setup.order.status == $setup.ORDER_STATUSES.pendingPayment]
              ]),
              _createVNode(_component_order_info, { order: $setup.order }, null, 8, ["order"])
            ]),
            _: 1
          }))
    ]),
    _: 3
  }))
}